import React from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  Link,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../images/LogoNavbar1.svg";

const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = React.useState({ email: "", password: "" });
  const [error, setError] = React.useState("");
  const message = location.state?.message || "";
  const messageSeverity = location.state?.messageSeverity || "success";
  const [loading, setLoading] = React.useState(false);

  const from = location.state?.from?.pathname || "/dashboard";

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      setError("");
      await login(form);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#F6F7FB", display: "grid", placeItems: "center", px: 2 }}>
      <Container maxWidth="xs">
        <Paper elevation={0} sx={{ p: { xs: 3, sm: 4 }, borderRadius: 4, border: "1px solid rgba(25,36,47,0.08)" }}>
          <Stack alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
            <Box component="img" src={logo} alt="WebProfit" sx={{ width: 64, height: 64, objectFit: "contain" }} />
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h4" sx={{ fontWeight: 950, color: BRAND.dark }}>
                Panel WebProfit
              </Typography>
              <Typography sx={{ color: "rgba(25,36,47,0.65)", mt: 0.5 }}>
                Ingresá para administrar proyectos y productos.
              </Typography>
            </Box>
          </Stack>

          {message && <Alert severity={messageSeverity} sx={{ mb: 2 }}>{message}</Alert>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <TextField label="Email" name="email" type="email" value={form.email} onChange={handleChange} required fullWidth />
              <TextField label="Contraseña" name="password" type="password" value={form.password} onChange={handleChange} required fullWidth />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: -1 }}>
                <Link component={RouterLink} to="/olvide-contrasena" sx={{ color: BRAND.orange, fontWeight: 850, fontSize: ".88rem" }}>
                  ¿Olvidaste tu contraseña?
                </Link>
              </Box>
              <Button type="submit" disabled={loading} variant="contained" size="large" sx={{ bgcolor: BRAND.orange, borderRadius: 999, textTransform: "none", fontWeight: 900, py: 1.25 }}>
                {loading ? "Ingresando..." : "Ingresar"}
              </Button>
            </Stack>
          </Box>

          <Typography sx={{ textAlign: "center", mt: 3, color: "rgba(25,36,47,0.7)" }}>
            ¿No tenés usuario?{" "}
            <Link component={RouterLink} to="/registro" sx={{ color: BRAND.orange, fontWeight: 900 }}>
              Crear cuenta
            </Link>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
